"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EditableListItem = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./EditableListItem.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * EditableListItem is a component that implements togglable UI for list items,
 * where a clickable "Remove" button causes an animation that reveals another
 * button, requiring a user to confirm their choice.
 *
 * This component provides the UI and functionality for this feature, while
 * the content of the list item may be entirely arbitrary, and is provided via
 * children.
 */
const EditableListItem = ({
  children,
  editLabel = 'Delete',
  initialOpen = false,
  onClick,
  onReorder,
  disabled = false,
  ...otherProps
}) => {
  const [expanded, setExpanded] = React.useState(initialOpen);

  const handleExpand = () => {
    setExpanded(true);
  };

  const handleCollapse = () => {
    setExpanded(false);
  };

  return (0, _pragma.createFelaElement)(_.View, _extends({
    alignItems: "center",
    css: css.root,
    cssProps: {
      disabled
    },
    flex: true,
    justifyContent: "flex-end"
  }, otherProps), (0, _pragma.createFelaElement)(_.View, {
    alignItems: "center",
    "aria-label": expanded ? 'Cancel' : undefined,
    as: expanded ? 'button' : undefined,
    css: css.content,
    cssProps: {
      expanded
    },
    gap: "medium",
    justifyContent: "space-between",
    onClick: expanded ? handleCollapse : undefined
  }, (0, _pragma.createFelaElement)(_.ButtonIcon, {
    "aria-label": editLabel,
    disabled: expanded,
    onClick: handleExpand,
    variant: "invisible",
    css: css.removeButtonIcon,
    cssProps: {
      expanded
    }
  }, (0, _pragma.createFelaElement)(_.RemoveCircleIcon, {
    color: disabled ? 'disabled.3' : 'interactive.sell.default',
    size: "large"
  })), (0, _pragma.createFelaElement)(_.View, {
    children: children,
    flex: true
  }), (0, _pragma.createFelaElement)(_.ButtonIcon, {
    as: expanded ? 'div' : undefined,
    disabled: expanded,
    onClick: expanded ? undefined : onReorder,
    variant: "invisible"
  }, (0, _pragma.createFelaElement)(_.ReorderIcon, {
    size: "large",
    color: "icon1"
  }))), (0, _pragma.createFelaElement)(_.View, {
    alignItems: "center",
    as: "button",
    type: "button",
    css: css.button,
    cssProps: {
      expanded
    },
    justifyContent: "center",
    onClick: onClick,
    padding: expanded ? 'medium' : ['medium', 'none']
  }, (0, _pragma.createFelaElement)(_.Text, {
    children: editLabel,
    color: "text.3",
    variant: "metaBold"
  })), (0, _pragma.createFelaElement)("div", {
    css: css.animatedBg
  }));
};

exports.EditableListItem = EditableListItem;
EditableListItem.displayName = 'EditableListItem';
var _default = EditableListItem;
exports.default = _default;
//# sourceMappingURL=EditableListItem.js.map